import { useEffect } from 'react';

export const useCloseWithESC = ({
  handleClose,
  ignore,
}: {
  handleClose: () => void;
  ignore?: boolean;
}) => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (ignore) {
        return;
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        handleClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [ignore]);
};
